import React from 'react';

import { StyleSheet } from 'react-native';

import { Box, BoxProps } from 'components/ui';
import { primitive } from 'styles/constants';

export const ProductCustomizationPanel = ({ style, ...props }: BoxProps) => (
  <Box {...props} style={[styles.productCustomizationPanel, style]} />
);

export const ModifierGroupContainer = ({ style, ...props }: BoxProps) => (
  <Box {...props} style={[styles.modifierGroupContainer, style]} />
);

export const ProductSelectedItemCustomizationContainer = ({ style, ...props }: BoxProps) => (
  <Box {...props} style={[styles.productSelectedItemCustomizationContainer, style]} />
);

const styles = StyleSheet.create({
  modifierGroupContainer: {
    margin: 0,
    padding: 0,
    width: '100%',
  },
  productCustomizationPanel: {
    alignSelf: 'center',
    height: '100%',
    width: '100%',
  },
  productSelectedItemCustomizationContainer: {
    backgroundColor: primitive.$blackOpacity4,
    borderRadius: primitive.$borderRadius,
    marginVertical: 16,
    paddingHorizontal: 8,
    paddingVertical: 16,
    width: '100%',
  },
});
